module.exports = __webpack_public_path__ + "static/media/science.6d6d2093.wav";